import React, { Component } from 'react';
import LandingPage from '@pages/LandingPage';
import AboutPage from '@pages/AboutPage';
import PublicationPage from '@pages/PublicationPage';
import ProjectPage from '@pages/ProjectPage';
import MiscPage from '@pages/MiscPage';
import ScrollTop from '@components/ScrollTop';
import ThemeSwitcher from '@components/ThemeSwitcher';
import Footer from '@components/Footer';

class App extends Component {

  render() {
    return (
      <div className="dev-landing-page">
        <ThemeSwitcher>
          <LandingPage />
          <AboutPage />
          <PublicationPage />
          <ProjectPage />
          <MiscPage />
          <ScrollTop />
          <Footer />
        </ThemeSwitcher>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js